import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CdnUrlService } from 'src/app/shared/services/cdn-url.service';

/**
 * Functional HTTP interceptor (Angular's modern replacement for class-based
 * HttpInterceptor). Rewrites legacy asset URLs in response bodies to the CDN.
 */
export function cdnUrlInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const cdnUrlService = inject(CdnUrlService);
  return next(request).pipe(
    map((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        const rewrittenBody = cdnUrlService.rewriteDeep(event.body);
        if (rewrittenBody !== event.body) {
          return event.clone({ body: rewrittenBody });
        }
      }
      return event;
    }),
  );
}
